import { getApiOrigin } from '@/config/env';
import { getToken } from '@/utils/auth';

export type CustomerReportRow = {
  uuid: string;
  createdAt: string;
  submissionIndex: number | null;
  contact: string | null;
  otpVerified: boolean;
  age: string | null;
  smoker: string | null;
  language: string | null;
  name: string | null;
  race: string | null;
  state: string | null;
  area: string | null;
  staffName: string | null;
  staffCode: string | null;
  prev_brand: string | null;
  prev_variant: string | null;
  category: string | null;
  prev_brand_reason: string | null;
  prev_brand_reason_detail: string | null;
  smoked_other_product: string | null;
  why_ld_now: string | null;
  other_prev_brand: string | null;
  other_prev_variant: string | null;
  other_category: string | null;
  other_prev_brand_reason: string | null;
  first_product_smoke_count: number | null;
  second_product_smoke_count: number | null;
  setbldvariant: string | null;
  setbldmotivation: string | null;
  setbldmotivation_detail: string | null;
  setbldfuturelikelihood: number | null;
  setbldfuturelikelihoodwhy: string | null;
  tng: string | null;
  tngValue: string | null;
  tng_sent: boolean | null;
  attempt: string | null;
  batch: string | null;
};

export async function fetchCustomerReportRows(input: {
  startISO: string;
  endISO: string;
}): Promise<CustomerReportRow[]> {
  const apiUrl = getApiOrigin();
  const params = new URLSearchParams({
    startDate: input.startISO,
    endDate: input.endISO,
  });

  const res = await fetch(`${apiUrl}/api/v1/admin/customers?${params.toString()}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  const data = (await res.json().catch(() => ({}))) as {
    ok?: boolean;
    data?: CustomerReportRow[];
    error?: string;
  };

  if (!res.ok || !data.ok || !Array.isArray(data.data)) {
    throw new Error(data.error || `Failed to load customer data (HTTP ${res.status})`);
  }

  return data.data;
}
